<template>
    <v-form-control :field="field">
        <template scope="api">
            <v-file-uploader :loader="loader" :name="field" :disabled="disabled" :files="files" @remove="$emit('remove', $event)" @input="handleChange($event, api)" :caption="caption" :label="label" :error="api.getTouched() ? api.getError() : undefined" />
        </template>
    </v-form-control>
</template>
<script>
    export default {
        name: 'form-file',
        props: {
            label: String,
            caption: String,
            error: [String, Object],
            field: {
                type: String,
                required: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            files: Array,
            loader: Boolean,
        },
        methods: {
            handleChange(files, api) {
                api.setValue(files);
                api.setTouched();

                if (!api.getError()) {
                    this.$emit('upload', files);
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// FormFile.vue?43141e58